import React, { useEffect, useRef } from 'react'
// AntV G2Plot
import { Pie } from '@antv/g2plot';
// i18
import { useTranslation } from 'react-i18next'

export const Pastel = ({graph}) => {
    const { t } = useTranslation(["translation"])
    const pieChartRef = useRef(null);

    useEffect(() => {
        const data = []

        if (graph===null) {
            data.push(
                {
                    name: `${t("example")} 1`,
                    value: 45,
                },
                {
                    name: `${t("example")} 2`,
                    value: 20,
                },
                {
                    name: `${t("example")} 3`,
                    value: 80,
                },
                {
                    name: `${t("example")} 4`,
                    value: 90,
                },
                {
                    name: `${t("example")} 5`,
                    value: 76,
                },
            )
        }
        else if(graph.channel) {
            const campos = graph.fields[graph.channel]
            campos.forEach(element => {
                const obj = {
                    name: element.name,
                    value: element.value
                }
                data.push(obj)
            });
        }
        else {
            const campos = graph.fields
            campos.forEach(element => {
                const obj = {
                    name: element.name,
                    value: element.value
                }
                data.push(obj)
            });
        }

        const piePlot = new Pie(pieChartRef.current, {
            data,
            angleField: 'value',
            colorField: 'name',
            legend: {
                position: 'right-top',
                itemSpacing: data.length + 1,
                itemName: {
                    style: {
                        fontSize: 15,
                    },
                },
            },
            label: {
                type: 'inner',
                offset: '-30%',
                content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
                style: {
                    textAlign: 'center',
                    fontSize: 16,
                },
            },
            interactions: [
                {
                    type: 'legend-filter',
                    enable: false,
                },
            ],
        });

        piePlot.render();

        return () => {
            piePlot.destroy();
        };
    }, []);

    return <div ref={pieChartRef} style={{ width: "80%", height: "80%" }} />;
}
